import React, { useEffect, useState, createElement, Component } from 'react';
import { motion } from 'framer-motion';
import { Anchor, ArrowLeft, BookOpen, Calendar, CheckCircle2, ClipboardList, Heart, LifeBuoy, MessageCircle, Phone, Send, Shield, Sparkles, Target, TrendingUp, Trophy, User, Users, Waves, Wind } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
const WHATSAPP_PHONE = '972548800260';
const sessionStructure = [{
  title: 'פתיחה וחיבור',
  duration: '10-15 דק׳',
  description: 'חימום גופני, תרגול נשימות ושיח ממוקד לפתיחת הלב והכנת הקבוצה לפעילות.',
  icon: Heart
}, {
  title: 'פעילות חווייתית במים',
  duration: '55-60 דק׳',
  description: 'הדרכה מקצועית, תרגול אישי וקבוצתי על הסאפ, וחוויית הצלחה מוחשית בכל מפגש.',
  icon: Waves
}, {
  title: 'עיבוד וסיכום',
  duration: '10-15 דק׳',
  description: 'שיח קבוצתי המתרגם את "שפת המים" והתגובות על הסאפ לתובנות וכלים לחיים.',
  icon: ClipboardList
}];
const programMilestones = [{
  range: 'מפגשים 1-3',
  title: 'בניית בסיס ואמון',
  description: 'יצירת אמון במרחב החדש, ביסוס יציבה ושליטה ראשונית, וזיהוי דפוסי התמודדות במים והקבלתם למקרים בחיי היום יום.',
  color: 'bg-sky-50 border-sky-200 text-sky-900',
  dotColor: 'bg-sky-400'
}, {
  range: 'מפגשים 4-6',
  title: 'הנפילה כמשאב',
  description: 'התמודדות עם איבוד שליטה, עלייה חזרה לסאפ, ותרגול מיינדפולנס ושקט פנימי על המים.',
  color: 'bg-cyan-50 border-cyan-200 text-cyan-900',
  dotColor: 'bg-cyan-400'
}, {
  range: 'מפגשים 7-10',
  title: 'העצמה ועיגון',
  description: 'תקשורת ואמון הדדי בקבוצה, אתגרי העצמה אישיים וקבוצתיים, ושיח מסכם המעגן את הכלים שנרכשו.',
  color: 'bg-blue-50 border-blue-200 text-blue-900',
  dotColor: 'bg-blue-400'
}];
const programBenefits = [{
  icon: Wind,
  title: 'ויסות רגשי וגופני',
  description: 'עבודה ממוקדת על נשימה, קואורדינציה וריכוז.'
}, {
  icon: Target,
  title: 'שבירת דפוסי פחד',
  description: 'התמודדות הדרגתית ומבוקרת עם מצבי אתגר ואי-ודאות.'
}, {
  icon: Sparkles,
  title: 'חוויית מסוגלות מיידית',
  description: 'רגעים מוחשיים של הצלחה המעצימים את הדימוי העצמי.'
}, {
  icon: Users,
  title: 'ריפוי קבוצתי',
  description: 'מרחב מוגן ותומך המעודד אמון הדדי ותקשורת בין משתתפי הקבוצה.'
}];
const safetyStandards = [{
  icon: Users,
  title: 'ליווי מקצועי במים',
  description: 'לפחות שני מדריכים מנוסים נמצאים במים בכל פעילות לאורך כל הסדרה.'
}, {
  icon: LifeBuoy,
  title: 'ציוד קצה מותאם',
  description: 'סאפים ומשוטים חדישים, חגורות הצלה אישיות ורצועות ביטחון (ליש) מחוברות לכל אורך הפעילות.'
}, {
  icon: Shield,
  title: 'מעטפת בטיחותית',
  description: 'תדריך בטיחות קפדני לפני כל יציאה, והתאמה מלאה של תוואי החתירה לתנאי מזג האוויר.'
}];
const team = [{
  name: 'עדי שמעוני',
  role: 'מנחת קבוצות ויחידים, מדריכת סאפ מוסמכת',
  bio: 'מביאה מעולם משאבי האנוש והליווי האישי הבנה עמוקה בתהליכי התפתחות, שינוי ובניית חוסן. בשנים האחרונות מדריכת סאפ קבוצות ויחידים.',
  image: 'https://cdn.magicpatterns.com/uploads/7UQXFa8QVzGYPRJjgEmh4j/c61b37f1-fb9e-4cd8-b43e-2e77a03ab830_(1).jpg'
}, {
  name: 'נחום שחר',
  role: 'מטפל ברפואה סינית, מדריך סאפ ומטפל גוף-נפש',
  bio: 'מטפל ברפואה סינית מעל 25 שנה. מתמחה בחיבור בין תנועה במים לוויסות ואיזון מערכת העצבים, מתוך גישה אינטגרטיבית של גוף-נפש.',
  image: 'https://cdn.magicpatterns.com/uploads/wit9BigVU3kkgjKMJuGwc6/PHOTO-2026-06-02-11-27-41.jpg',
  imagePosition: '62% 6%'
}];
const personalProgramGoals = ['פיתוח ביטחון עצמי וחוסן נפשי באמצעות חוויות הצלחה והתגברות על אתגרים', 'חיזוק יכולות פיזיות ומוטוריות – שיפור שיווי משקל וקואורדינציה', 'טיפוח חיבור לטבע ולגוף באמצעות פעילות ימית חווייתית', 'פיתוח מיומנויות התמודדות עם מצבי לחץ, שינוי ואי־ודאות', 'חיזוק הקשר הבין־אישי עם המנחה ושילוב שיח רגשי מותאם', 'מניעת התדרדרות לפעילויות מסכנות או עברייניות'];
const personalProgramObjectives = ['חיזוק הקשר האישי בין המנחה למשתתף, תוך יצירת חוויות הצלחה מותאמות', 'פיתוח תחושת המסוגלות והעלאת הערך העצמי', 'שיפור כישורי חיים – קבלת החלטות, התמדה ושיתוף פעולה', 'הקניית כלים לשמירה על כללים וחוקים', 'הפחתת מצבי סיכון והגברת המוטיבציה להשתלבות חיובית בקהילה'];
const personalSuccessMetrics = ['נוכחות והתמדה בשיעור של 80% ומעלה', 'שיפור נצפה בשיתוף פעולה, התמדה וביטחון עצמי', 'ירידה בדיווחים על התנהגויות מסכנות', 'שביעות רצון גבוהה של המשתתפים והצוות המפנה'];
const personalSyllabus = [{
  number: 1,
  title: 'היכרות וביטחון ראשוני',
  points: ['יצירת קשר ואמון', 'היכרות עם הציוד וכללי בטיחות', 'התנסות בחתירה בישיבה/כריעה'],
  dialogue: '"מה נותן לי תחושת ביטחון?"'
}, {
  number: 2,
  title: 'עמידה והתקדמות',
  points: ['מעבר מישיבה לעמידה', 'טכניקת חתירה בסיסית בעמידה', 'שמירה על יציבות בתנועה'],
  dialogue: '"מה עזר לי לנסות משהו חדש?"'
}, {
  number: 3,
  title: 'שליטה וכיוון',
  points: ['חיזוק טכניקה והחזקת משוט נכונה', 'שינויי כיוון ובלימה', 'משימה: הגעה ליעד מוגדר במסלול'],
  dialogue: '"איך אני מתמודד כשמשהו לא הולך כמתוכנן?"'
}, {
  number: 4,
  title: 'נפילה וקימה',
  points: ['תרגול נפילה בטוחה', 'עלייה חזרה לסאפ במים עמוקים'],
  dialogue: '"חוויה אישית של נפילה ואיך קמתי ממנה"'
}, {
  number: 5,
  title: 'חתירה רציפה ואתגר אישי',
  points: ['מסלול חתירה ארוך יותר', 'הצבת יעד מותאם יכולת'],
  dialogue: '"מה מרגיש לי הישג?"'
}, {
  number: 6,
  title: 'שקט פנימי ומיינדפולנס במים',
  points: ['חתירה איטית ומודעת לנשימה', 'תרגילי שקט וקשב'],
  dialogue: '"איפה אני מוצא שקט בחיי?"'
}, {
  number: 7,
  title: 'משימת העצמה אישית',
  points: ['אתגר מותאם אישית (שיווי משקל, מרחק, טכניקה)'],
  dialogue: '"איך מתכוננים לאתגר? מה עוזר לי להצליח?"'
}, {
  number: 8,
  title: 'סיכום וחגיגה',
  points: ['חתירה המשלבת את כל הטכניקות שנלמדו', 'סיכום אישי של התהליך והדגשת חוזקות'],
  dialogue: '"מה אני לוקח איתי לחיים מהתהליך?"'
}];
const testimonials = [{
  quote: 'המים החזירו לי את השקט שהלך לאיבוד ב-7 באוקטובר. בפעם הראשונה אחרי הרבה זמן, הצלחתי לנשום נשימה עמוקה ולהרגיש את הגוף שלי בלי לרצות לברוח ממנו.',
  author: 'משתתפת',
  context: 'מקבוצת שורדי הנובה'
}, {
  quote: 'העבודה עם עדי ונחום מאפשרת למטופלים שלנו לעבור תהליך עומק שאף חדר טיפולים סגור לא יכול להציע. המקצועיות, הרגישות לטראומה וההתאמה האישית הן ברמה הגבוהה ביותר.',
  author: 'נציגת מחלקת הרווחה',
  context: 'עיריית צפת'
}];
export function SafeSpaceOnWaterPage() {
  const [form, setForm] = useState({
    fullName: '',
    organization: '',
    phone: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    document.title = "מרחב בטוח על המים - תוכניות חוסן | ביץ' קלאב מעגן";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'תוכניות חוסן והעצמה על המים לעמותות, מחלקות רווחה וקרנות. תהליך מובנה של ויסות, חוסן ומסוגלות באמצעות סאפ, מיינדפולנס ועיבוד קבוצתי.');
  }, []);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.fullName.trim() || !form.phone.trim()) return;
    setIsSubmitting(true);
    // Open WhatsApp with prefilled message — same low-friction pattern used elsewhere on the site
    const text = encodeURIComponent(`היי, אני ${form.fullName}${form.organization ? ` מ-${form.organization}` : ''}.\nאני מתעניין/ת בתוכנית "מרחב בטוח על המים" עבור מטופלי הארגון שלנו.\n${form.message ? `\nפרטים: ${form.message}\n` : ''}\nטלפון: ${form.phone}${form.email ? `\nאימייל: ${form.email}` : ''}`);
    const url = `https://wa.me/${WHATSAPP_PHONE}?text=${text}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    setSubmitted(true);
    setIsSubmitting(false);
  };
  return <div className="min-h-screen bg-slate-50 text-slate-900" dir="rtl" data-id="element-1128">
      <Navigation data-id="element-1129" />

      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden" data-id="element-1130">
        <div className="absolute inset-0 z-0" data-id="element-1131">
          <img src="https://cdn.magicpatterns.com/uploads/pb2oCkPyfe9oskTmycrukm/89f10491-a91f-4aaa-9e3f-7c79bc220200.jpg" alt="קבוצה חותרת על סאפים בכנרת" className="w-full h-full object-cover" data-id="element-1132" />
          <div className="absolute inset-0 bg-gradient-to-l from-slate-900/85 via-slate-900/75 to-sky-900/70" data-id="element-1133" />
        </div>

        <div className="relative z-10 container mx-auto px-4 max-w-5xl" data-id="element-1134">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-1135">
            <div className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-sky-400/15 border border-sky-300/40 text-sky-100 text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-1136">
              <Anchor className="w-4 h-4" data-id="element-1137" />
              <span data-id="element-1138">תוכניות חוסן והעצמה למוסדות</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6 max-w-4xl" data-id="element-1139">
              מחזירים את העוגן לחיים:
              <br data-id="element-1140" />
              <span className="text-sky-200" data-id="element-1141">
                תוכניות חוסן מותאמות אישית על המים
              </span>
            </h1>
            <p className="text-lg md:text-xl text-slate-100 leading-relaxed max-w-3xl mb-6 font-light" data-id="element-1142">
              מועדון הספורט הימי במעגן עדן מזמין עמותות, ארגונים ומחלקות רווחה
              להעניק למטופלים שלהם תהליך חווייתי וייחודי של התפתחות, חיבור לגוף
              ויציאה משיתוק לעשייה – באמצעות שילוב מובנה של חתירת סאפ,
              מיינדפולנס ועיבוד קבוצתי.
            </p>
            <p className="text-base md:text-lg text-sky-100 leading-relaxed max-w-3xl mb-10 font-light" data-id="element-1143">
              אנחנו מציעים סדרות מפגשים קבוצתיים לצד{' '}
              <span className="font-semibold text-white" data-id="element-1144">
                מפגשי העצמה אישיים
              </span>{' '}
              — כל תוכנית נבנית באופן מותאם אישית לקהל היעד ולמטרות הארגון.
            </p>
            <a href="#contact" className="inline-flex items-center gap-2 bg-sky-500 hover:bg-sky-600 text-white text-base md:text-lg font-bold py-4 px-8 rounded-full transition-all shadow-xl shadow-sky-900/30 hover:scale-[1.02]" data-id="element-1145">
              לתאום פגישת ייעוץ
              <ArrowLeft className="w-5 h-5" data-id="element-1146" />
            </a>
          </motion.div>
        </div>
      </section>

      {/* Why Water & SUP */}
      <section className="py-20 md:py-24 bg-white" data-id="element-1147">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-1148">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-1149">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1150">
              הצורך והפתרון
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1151">
              למה דווקא מים וסאפ?
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="space-y-6 text-lg text-slate-700 leading-relaxed" data-id="element-1152">
            <p data-id="element-1153">
              כאשר מתמודדים עם פוסט-טראומה, חרדה או משברים נפשיים, לעיתים קרובות
              המילים לבדן אינן מספיקות.
              <span className="font-semibold text-slate-900" data-id="element-1154">
                {' '}
                הטראומה נצרבת בגוף
              </span>
              , והדרך לחזור לתחושת שליטה וחוסן עוברת דרך תנועה, חוויית מסוגלות
              והתמודדות מבוקרת עם אי-ודאות.
            </p>
            <p data-id="element-1155">
              על גבי הסאפ, מול מרחבי הכנרת, המטופלים פוגשים את האלמנטים המשתנים
              של הטבע (רוח, גלים) בסביבה מוגנת לחלוטין.
            </p>
            <p data-id="element-1156">
              כל שמירה על שיווי משקל, כל חתירה קדימה וכל עלייה חזרה לסאפ לאחר
              נפילה –{' '}
              <span className="font-semibold text-sky-700" data-id="element-1157">
                מתורגמות באופן מיידי לכלים פרקטיים, ביטחון עצמי וחוסן מנטלי
                בחיים עצמם.
              </span>
            </p>
          </motion.div>
        </div>
      </section>

      {/* Visual break — youth paddling on the Kinneret */}
      <section className="relative h-[260px] sm:h-[340px] md:h-[420px] overflow-hidden" data-id="element-1158">
        <img src="https://cdn.magicpatterns.com/uploads/kTa2nmck7dQy3kE5LemFns/%D7%99%D7%9C%D7%93%D7%99%D7%9D.jpg" alt="בני נוער חותרים בשמחה על סאפים בכנרת" className="w-full h-full object-cover" data-id="element-1159" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 via-slate-900/10 to-transparent" data-id="element-1160" />
        <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 max-w-md text-white" data-id="element-1161">
          <p className="text-base md:text-lg font-semibold leading-snug drop-shadow-md" data-id="element-1162">
            כשהאתגר הופך לחיוך – רגעי מסוגלות והצלחה על המים.
          </p>
        </div>
      </section>

      {/* Core Message — Tailored */}
      <section className="py-20 md:py-24 bg-gradient-to-b from-sky-50 to-slate-50" data-id="element-1163">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1164">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1165">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1166">
              הייחודיות שלנו
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1167">
              תוכניות מותאמות אישית
            </h2>
            <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1168">
              אנחנו מאמינים בהקשבה לצרכים שלכם. הבסיס המקצועי שלנו נשען על
              תוכניות מובנות, אך כל סדרת מפגשים נבנית ומותאמת אישית לקהל היעד
              הספציפי של הקבוצה שלכם.
            </p>
          </motion.div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-1169">
            {programBenefits.map((b, i) => <motion.div key={b.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-white rounded-2xl p-7 border border-slate-200 hover:border-sky-300 hover:shadow-lg transition-all" data-id="element-1170">
                <div className="w-12 h-12 rounded-xl bg-sky-100 flex items-center justify-center mb-4" data-id="element-1171">
                  <b.icon className="w-6 h-6 text-sky-600" data-id="element-1172" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1173">
                  {b.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-1174">
                  {b.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Process Structure */}
      <section className="py-20 md:py-24 bg-white" data-id="element-1175">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1176">
          {/* Program milestones — example */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1177">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1178">
              המתודולוגיה
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1179">
              אבני הדרך לאורך הסדרה
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-1180">
              דוגמה ממבנה תוכנית בת 10 מפגשים, מותאמת באופן ספציפי לכל קבוצה
            </p>
          </motion.div>

          <div className="relative max-w-4xl mx-auto" data-id="element-1181">
            {/* Vertical line */}
            <div className="absolute top-0 bottom-0 right-6 md:right-1/2 md:translate-x-1/2 w-px bg-slate-200" data-id="element-1182" />
            <div className="space-y-8" data-id="element-1183">
              {programMilestones.map((m, i) => <motion.div key={m.range} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="relative flex gap-6 items-start" data-id="element-1184">
                  <div className={`relative z-10 shrink-0 w-12 h-12 rounded-full ${m.dotColor} ring-4 ring-white shadow-md flex items-center justify-center text-white font-bold`} data-id="element-1185">
                    {i + 1}
                  </div>
                  <div className={`flex-1 rounded-2xl border p-6 ${m.color}`} data-id="element-1186">
                    <div className="text-xs font-semibold tracking-wider uppercase opacity-70 mb-1" data-id="element-1187">
                      {m.range}
                    </div>
                    <h4 className="text-xl font-bold mb-2" data-id="element-1188">{m.title}</h4>
                    <p className="leading-relaxed opacity-90" data-id="element-1189">
                      {m.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Personal Sessions — Additional Offering */}
      <section className="py-20 md:py-24 bg-gradient-to-b from-white via-sky-50/40 to-white" data-id="element-1190">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1191">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1192">
            <div className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-sky-100 border border-sky-200 text-sky-700 text-sm font-semibold mb-5" data-id="element-1193">
              <User className="w-4 h-4" data-id="element-1194" />
              <span data-id="element-1195">מוצר נוסף • ליווי אישי</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1196">
              מפגשי העצמה אישיים
            </h2>
            <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1197">
              בנוסף לסדרת המפגשים הקבוצתיים, אנחנו מציעים מפגשי העצמה אישיים
              שתכליתם ללוות תהליכי התפתחות אישיים, להתמודד עם פחדים, להבין את
              מקורם ולהקנות כלים לחיים.
            </p>
            <p className="text-base text-slate-500 max-w-2xl mx-auto leading-relaxed mt-4 italic" data-id="element-1198">
              להלן דוגמה לסילבוס שנבנה לתוכנית בת 8 מפגשים — כל תוכנית נבנית
              באופן מותאם אישית למשתתף.
            </p>
          </motion.div>

          {/* Goals & Objectives — two columns */}
          <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-1199">
            {/* Goals */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white border border-slate-200 rounded-3xl p-7 md:p-8 shadow-sm" data-id="element-1200">
              <div className="flex items-center gap-3 mb-5" data-id="element-1201">
                <div className="w-11 h-11 rounded-xl bg-sky-100 flex items-center justify-center" data-id="element-1202">
                  <Target className="w-5 h-5 text-sky-600" data-id="element-1203" />
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-slate-900" data-id="element-1204">
                  מטרות התוכנית
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-1205">
                {personalProgramGoals.map((goal, i) => <li key={i} className="flex items-start gap-3" data-id="element-1206">
                    <div className="shrink-0 w-6 h-6 rounded-full bg-sky-50 border border-sky-200 flex items-center justify-center mt-0.5" data-id="element-1207">
                      <span className="text-xs font-bold text-sky-700" data-id="element-1208">
                        {i + 1}
                      </span>
                    </div>
                    <span className="text-slate-700 leading-relaxed" data-id="element-1209">
                      {goal}
                    </span>
                  </li>)}
              </ul>
            </motion.div>

            {/* Objectives */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-white border border-slate-200 rounded-3xl p-7 md:p-8 shadow-sm" data-id="element-1210">
              <div className="flex items-center gap-3 mb-5" data-id="element-1211">
                <div className="w-11 h-11 rounded-xl bg-cyan-100 flex items-center justify-center" data-id="element-1212">
                  <TrendingUp className="w-5 h-5 text-cyan-600" data-id="element-1213" />
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-slate-900" data-id="element-1214">
                  יעדי התוכנית
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-1215">
                {personalProgramObjectives.map((obj, i) => <li key={i} className="flex items-start gap-3" data-id="element-1216">
                    <div className="shrink-0 w-6 h-6 rounded-full bg-cyan-50 border border-cyan-200 flex items-center justify-center mt-0.5" data-id="element-1217">
                      <span className="text-xs font-bold text-cyan-700" data-id="element-1218">
                        {i + 1}
                      </span>
                    </div>
                    <span className="text-slate-700 leading-relaxed" data-id="element-1219">
                      {obj}
                    </span>
                  </li>)}
              </ul>
            </motion.div>
          </div>

          {/* Success Metrics */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-sky-600 to-cyan-600 rounded-3xl p-7 md:p-10 mb-14 shadow-lg" data-id="element-1220">
            <div className="flex items-center gap-3 mb-6" data-id="element-1221">
              <div className="w-11 h-11 rounded-xl bg-white/15 backdrop-blur-sm flex items-center justify-center border border-white/20" data-id="element-1222">
                <Trophy className="w-5 h-5 text-white" data-id="element-1223" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-1224">
                מדדי הצלחה
              </h3>
            </div>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-1225">
              {personalSuccessMetrics.map((metric, i) => <div key={i} className="flex items-start gap-3 bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl p-4" data-id="element-1226">
                  <CheckCircle2 className="w-5 h-5 text-sky-100 shrink-0 mt-0.5" data-id="element-1227" />
                  <span className="text-white font-medium leading-relaxed" data-id="element-1228">
                    {metric}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* Syllabus — 8 sessions */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-1229">
            <div className="inline-flex items-center gap-2 text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1230">
              <BookOpen className="w-4 h-4" data-id="element-1231" />
              <span data-id="element-1232">הסילבוס</span>
            </div>
            <h3 className="text-2xl md:text-4xl font-bold text-slate-900 mb-3 leading-tight" data-id="element-1233">
              דוגמה למבנה 8 מפגשים אישיים
            </h3>
            <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-1234">
              כל מפגש משלב חוויה במים, התמודדות עם אתגר ושיח אישי מותאם.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-5" data-id="element-1235">
            {personalSyllabus.map((session, i) => <motion.div key={session.number} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="group bg-white border border-slate-200 hover:border-sky-300 rounded-2xl p-6 transition-all hover:shadow-lg" data-id="element-1236">
                <div className="flex items-start gap-4 mb-4" data-id="element-1237">
                  <div className="shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-sky-500 to-cyan-500 text-white flex items-center justify-center font-bold text-lg shadow-md shadow-sky-500/20" data-id="element-1238">
                    {session.number}
                  </div>
                  <div className="flex-1 pt-1" data-id="element-1239">
                    <div className="text-xs font-semibold tracking-wider uppercase text-sky-600 mb-1" data-id="element-1240">
                      מפגש {session.number}
                    </div>
                    <h4 className="text-lg font-bold text-slate-900 leading-tight" data-id="element-1241">
                      {session.title}
                    </h4>
                  </div>
                </div>

                <ul className="space-y-2 mb-4 pr-1" data-id="element-1242">
                  {session.points.map((point, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-slate-700 leading-relaxed" data-id="element-1243">
                      <div className="shrink-0 w-1.5 h-1.5 rounded-full bg-sky-400 mt-2" data-id="element-1244" />
                      <span data-id="element-1245">{point}</span>
                    </li>)}
                </ul>

                <div className="pt-4 border-t border-slate-100" data-id="element-1246">
                  <div className="flex items-start gap-2" data-id="element-1247">
                    <MessageCircle className="w-4 h-4 text-cyan-500 shrink-0 mt-0.5" data-id="element-1248" />
                    <div data-id="element-1249">
                      <div className="text-xs font-semibold text-slate-500 mb-0.5" data-id="element-1250">
                        שיח אישי
                      </div>
                      <p className="text-sm text-slate-700 italic leading-relaxed" data-id="element-1251">
                        {session.dialogue}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mt-12" data-id="element-1252">
            <a href="#contact" className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-base font-bold py-4 px-8 rounded-full transition-all shadow-xl shadow-slate-900/20 hover:scale-[1.02]" data-id="element-1253">
              לתאום ייעוץ על מפגשים אישיים
              <ArrowLeft className="w-5 h-5" data-id="element-1254" />
            </a>
          </motion.div>
        </div>
      </section>

      {/* Safety */}
      <section className="py-20 md:py-24 bg-slate-900 text-white" data-id="element-1255">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1256">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1257">
            <div className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-sky-500/15 border border-sky-400/30 text-sky-200 text-sm font-medium mb-5" data-id="element-1258">
              <Shield className="w-4 h-4" data-id="element-1259" />
              <span data-id="element-1260">בטיחות ללא פשרות</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-5 leading-tight" data-id="element-1261">
              כדי שתוכלו לשלוח את המטופלים בלב שקט
            </h2>
            <p className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-1262">
              אנו מחויבים לסטנדרטים המחמירים ביותר בכל היבטי הבטיחות במים.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-1263">
            {safetyStandards.map((s, i) => <motion.div key={s.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-slate-800/60 border border-slate-700 rounded-2xl p-7 backdrop-blur-sm" data-id="element-1264">
                <div className="w-12 h-12 rounded-xl bg-sky-500/15 border border-sky-400/30 flex items-center justify-center mb-4" data-id="element-1265">
                  <s.icon className="w-6 h-6 text-sky-300" data-id="element-1266" />
                </div>
                <h3 className="text-lg font-bold text-white mb-3" data-id="element-1267">{s.title}</h3>
                <p className="text-slate-300 text-sm leading-relaxed" data-id="element-1268">
                  {s.description}
                </p>
              </motion.div>)}
          </div>

          {/* Visual proof of safety — life vests on participants */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-12 relative rounded-3xl overflow-hidden border border-slate-700" data-id="element-1269">
            <img src="https://cdn.magicpatterns.com/uploads/uNaUCPW3BbJoisw3idg4Ne/44430867-7980-4c61-9fd5-297d5b7addc5.jpg" alt="קבוצה עם חגורות הצלה מסודרת לפני יציאה למים" className="w-full h-64 md:h-80 object-cover" data-id="element-1270" />
            <div className="absolute inset-0 bg-gradient-to-l from-slate-900/70 via-slate-900/20 to-transparent" data-id="element-1271" />
            <div className="absolute inset-0 flex items-center px-6 md:px-10" data-id="element-1272">
              <p className="max-w-md text-white text-sm md:text-base font-medium leading-relaxed drop-shadow-md" data-id="element-1273">
                כל יציאה למים מתחילה בתדריך בטיחות וציוד הצלה אישי לכל משתתף –
                הסביבה מוגנת לחלוטין, גם כשהאתגר אישי.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 md:py-24 bg-white" data-id="element-1274">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1275">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1276">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1277">
              הצוות המקצועי
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1278">
              האנשים שמובילים את התהליך
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1279">
            {team.map((member, i) => <motion.div key={member.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-slate-50 border border-slate-200 rounded-3xl overflow-hidden" data-id="element-1280">
                {member.image ? <div className="relative h-64 overflow-hidden" data-id="element-1281">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                objectPosition: member.imagePosition || '50% 50%'
              }} data-id="element-1282" />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent" data-id="element-1283" />
                  </div> : <div className="relative h-64 overflow-hidden bg-gradient-to-br from-sky-100 via-sky-50 to-slate-100 flex items-center justify-center" data-id="element-1284">
                    <div className="w-24 h-24 rounded-full bg-white/70 border border-sky-200 flex items-center justify-center shadow-sm" data-id="element-1285">
                      <span className="text-3xl font-bold text-sky-700" data-id="element-1286">
                        {member.name.charAt(0)}
                      </span>
                    </div>
                  </div>}
                <div className="p-7" data-id="element-1287">
                  <h3 className="text-2xl font-bold text-slate-900 mb-1" data-id="element-1288">
                    {member.name}
                  </h3>
                  <p className="text-sky-600 font-semibold text-sm mb-4" data-id="element-1289">
                    {member.role}
                  </p>
                  <p className="text-slate-600 leading-relaxed" data-id="element-1290">{member.bio}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Gallery mosaic — authentic moments from the field */}
      <section className="py-16 md:py-20 bg-slate-50" data-id="element-1291">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-1292">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-1293">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1294">
              רגעים מהשטח
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-slate-900 leading-tight" data-id="element-1295">
              ככה זה נראה אצלנו על המים
            </h2>
            <p className="text-slate-600 mt-3 max-w-2xl mx-auto" data-id="element-1296">
              תמונות אותנטיות ממפגשי הקבוצות והסדרות שלנו בכנרת
            </p>
          </motion.div>

          {/* Featured wide shot — community on the water */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative aspect-[16/7] overflow-hidden rounded-2xl border border-slate-200 group mb-4 md:mb-6" data-id="element-1297">
            <img src="https://cdn.magicpatterns.com/uploads/noLmPvWjr5SRoEyjmUkGZF/e74f9f3c-a78a-45c4-8dea-b0c7c0f86bca.jpg" alt="קבוצה גדולה חותרת יחד על סאפים בכנרת" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1298" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent" data-id="element-1299" />
            <div className="absolute bottom-5 right-5 md:bottom-7 md:right-7 max-w-md" data-id="element-1300">
              <p className="text-white text-sm md:text-base font-semibold drop-shadow-md" data-id="element-1301">
                כוח הקבוצה — חתירה משותפת על הכנרת.
              </p>
            </div>
          </motion.div>

          {/* Mosaic grid — authentic field moments */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-1302">
            {[{
            src: 'https://cdn.magicpatterns.com/uploads/4EdwGkuFdCRT2x9p7TMsqn/d614f3cc-c15c-44ca-8678-26421fe3560a.jpg',
            alt: 'תרגול חימום ותנועה לפני יציאה למים'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/vHnihWkpAcZUcuKyj32dxq/GetAttachmentThumbnail_(5).jpg',
            alt: 'משתתפים על סאפים במים שקטים בזריחה'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/1ocePwf9rkmwuHh1H9pSRx/939A3565.jpg',
            alt: 'הסאפים מוכנים על החוף — שעת בוקר בכנרת'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/5nGxiXmrUekLw5TSXSsSo9/287d3c34-35e3-43a7-969b-4f2d0a812169.jpg',
            alt: 'רגע של שקט ומיינדפולנס על המים'
          }, {
            src: 'https://cdn.magicpatterns.com/uploads/nwAWSPsL8aY4Qi2gmods16/GetAttachmentThumbnail_(6).jpg',
            alt: 'מבט על החוף והציוד — הבית של הסדרות שלנו'
          }].map((img, i) => <motion.div key={img.src} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="relative aspect-[4/3] overflow-hidden rounded-2xl border border-slate-200 group" data-id="element-1303">
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1304" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1305" />
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 md:py-24 bg-gradient-to-b from-slate-50 to-sky-50" data-id="element-1306">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-1307">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-14" data-id="element-1308">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1309">
              מן השטח
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1310">
              עדויות וסיפורי הצלחה
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-1311">
            {testimonials.map((t, i) => <motion.div key={t.author} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white border border-slate-200 rounded-3xl p-8 shadow-sm" data-id="element-1312">
                <div className="text-6xl font-serif text-sky-200 leading-none mb-2" data-id="element-1313">
                  "
                </div>
                <p className="text-lg text-slate-800 leading-relaxed mb-6 -mt-4" data-id="element-1314">
                  {t.quote}
                </p>
                <div className="flex items-center gap-3 pt-4 border-t border-slate-100" data-id="element-1315">
                  <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center" data-id="element-1316">
                    <Heart className="w-5 h-5 text-sky-600" data-id="element-1317" />
                  </div>
                  <div data-id="element-1318">
                    <div className="font-bold text-slate-900" data-id="element-1319">{t.author}</div>
                    <div className="text-sm text-slate-500" data-id="element-1320">{t.context}</div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact" className="py-20 md:py-24 bg-white scroll-mt-20" data-id="element-1321">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-1322">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-1323">
            <span className="inline-block text-sky-600 font-semibold text-sm tracking-wider uppercase mb-3" data-id="element-1324">
              נדבר בהמשך
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-5 leading-tight" data-id="element-1325">
              בואו נבנה יחד את מרחב הצמיחה הבא
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-1326">
              השאירו פרטים, ונחזור אליכם כדי לתאם פגישה (בזום או על כוס קפה מול
              הכנרת אצלנו במועדון), לשמוע על הצרכים הייחודיים של הארגון שלכם
              ולגבש תוכנית מותאמת.
            </p>
          </motion.div>

          {submitted ? <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-emerald-50 border border-emerald-200 rounded-3xl p-10 text-center" data-id="element-1327">
              <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4" data-id="element-1328">
                <CheckCircle2 className="w-8 h-8 text-emerald-600" data-id="element-1329" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-1330">
                תודה! פתחנו עבורך וואטסאפ
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-1331">
                המשיכי את ההודעה בוואטסאפ עם הפרטים הקצרים שמילאת, ונחזור אלייך
                בהקדם.
              </p>
            </motion.div> : <motion.form onSubmit={handleSubmit} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 border border-slate-200 rounded-3xl p-8 md:p-10 space-y-5" data-id="element-1332">
              <div className="grid md:grid-cols-2 gap-5" data-id="element-1333">
                <div data-id="element-1334">
                  <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1335">
                    שם מלא <span className="text-sky-600" data-id="element-1336">*</span>
                  </label>
                  <input type="text" name="fullName" value={form.fullName} onChange={handleChange} required disabled={isSubmitting} className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all" data-id="element-1337" />
                </div>
                <div data-id="element-1338">
                  <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1339">
                    שם העמותה / הארגון
                  </label>
                  <input type="text" name="organization" value={form.organization} onChange={handleChange} disabled={isSubmitting} placeholder="עמותה, מחלקת רווחה, קרן..." className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all" data-id="element-1340" />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-5" data-id="element-1341">
                <div data-id="element-1342">
                  <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1343">
                    טלפון <span className="text-sky-600" data-id="element-1344">*</span>
                  </label>
                  <input type="tel" name="phone" value={form.phone} onChange={handleChange} required disabled={isSubmitting} placeholder="050-1234567" dir="ltr" className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all text-right" data-id="element-1345" />
                </div>
                <div data-id="element-1346">
                  <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1347">
                    אימייל
                  </label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} disabled={isSubmitting} placeholder="name@example.com" dir="ltr" className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all text-right" data-id="element-1348" />
                </div>
              </div>

              <div data-id="element-1349">
                <label className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-1350">
                  ספרו לנו על הצורך
                </label>
                <textarea name="message" value={form.message} onChange={handleChange} disabled={isSubmitting} rows={4} placeholder="קהל היעד, גודל הקבוצה, מה הייתם רוצים להשיג..." className="w-full bg-white border border-slate-200 rounded-xl py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-300 transition-all resize-none" data-id="element-1351" />
              </div>

              <button type="submit" disabled={isSubmitting} className="w-full inline-flex items-center justify-center gap-2 bg-sky-600 hover:bg-sky-700 text-white font-bold py-4 rounded-2xl transition-all shadow-lg shadow-sky-600/20 hover:scale-[1.01] disabled:opacity-70" data-id="element-1352">
                <Send className="w-5 h-5" data-id="element-1353" />
                שליחת פרטים – נשמח לדבר
              </button>

              <p className="text-center text-xs text-slate-500 pt-1" data-id="element-1354">
                לחיצה תפתח שיחת וואטסאפ עם הפרטים שמילאת
              </p>
            </motion.form>}

          {/* Direct contact */}
          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-slate-600" data-id="element-1355">
            <a href={`https://wa.me/${WHATSAPP_PHONE}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-emerald-600 transition-colors" data-id="element-1356">
              <MessageCircle className="w-5 h-5" data-id="element-1357" />
              שליחת הודעה ישירה בוואטסאפ
            </a>
            <span className="text-slate-300" data-id="element-1358">•</span>
            <a href="tel:0548800260" className="inline-flex items-center gap-2 hover:text-sky-600 transition-colors" data-id="element-1359">
              <Phone className="w-5 h-5" data-id="element-1360" />
              054-8800260
            </a>
          </div>
        </div>
      </section>

      <Footer data-id="element-1361" />
    </div>;
}